<template>
  <validation-observer
    ref="form-filing-filer-status"
    tag="form"
  >
    <div class="section content">
      <div
        v-if="readOnly"
        class="columns"
      >
        <div class="column">
          <div class="message">
            <div class="message-body">
              <p>This section is disabled. Changes must be done by a system administrator.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column has-text-centered">
          <h2 class="title is-2">
            User Access Status
          </h2>
          <div class="subtitle is-2">
            An inactive user is not able to login.
          </div>
        </div>
      </div>
      <div class="columns is-centered">
        <div
          v-for="status in statuses"
          :key="status.key"
          class="column is-one-third has-text-centered"
        >
          <checkbox-adv
            :id="status.key"
            v-model="checkedStatuses"
            :value="status.key"
            :disabled="readOnly"
          >
            {{ status.label }}
          </checkbox-adv>
        </div>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';
import CheckboxAdv from '@/components/phila-ui/CheckboxAdv';

export default {
  name: 'UserAccessStatus',
  components: {
    CheckboxAdv,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  props: {
    type: {
      type: String,
      default: 'user',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      profile: {
        active: 'N',
        canRedact: 'N',
      },
      statuses: {},
      checkedStatuses: [],
      userStatusReady: false,
    };
  },
  computed: {

  },
  watch: {
    checkedStatuses: {
      async handler () {
        let statusObj = {
          active: 'N',
          canRedact: 'N',
        };
        Object.keys(this.statuses).forEach(status => {
          if (this.checkedStatuses.includes(status)) {
            statusObj[status] = 'Y';
          }
        });
        this.$emit('userAccessStatuses', statusObj);
      },
    },
  },
  async created () {
    await this.initialFetch();
    await this.initialAssign();
    this.$emit('userStatusReady', true);
  },
  methods: {
    async initialAssign () {
      if (this.type === 'user') {
        this.profile = await this.getUserProfile();
      } else if (this.type === 'tempUser') {
        this.profile = await this.getTempUserProfile();
      }
      this.statuses = {
        active: {
          label: 'Active',
          key: 'active',
        },
      };

      if (this.profile.sysAdmin === 'Y') {
        this.statuses.canRedact = {
          label: 'Can Redact',
          key: 'canRedact',
        };
      }

      if (this.profile.active === 'Y') {
        this.checkedStatuses.push('active');
      }
      if (this.profile.canRedact === 'Y') {
        this.checkedStatuses.push('canRedact');
      }
    },
    async initialFetch () {
      let promises = [];
      if (this.type === 'user') {
        // promises.push(this.$store.dispatch('user/fetchUserProfile'));
      } else if (this.type === 'tempUser') {
        promises.push(this.$store.dispatch('user/fetchUserProfile', this.$store.state.user.tempId));
      }
      await Promise.all(promises);
    },
    getUserProfile () {
      return this.cloneObj(this.$store.state.user.profile);
    },
    getTempUserProfile () {
      return this.cloneObj(this.$store.state.user.tempProfile);
    },
  },
};
</script>
